export enum Partners {
    Carrefour = 1,
    Zeotap = 2,
    Weborama = 3,
    Afilead = 4,
    Citiservi = 5,
    Fintonic = 8,
    Logan = 9
}